import { v4 as uuidv4 } from 'uuid';
import { ANONYMOUS_SESSION_KEY } from '@tools-beaver/shared';

export const getOrCreateSessionId = (): string => {
  let sessionId = localStorage.getItem(ANONYMOUS_SESSION_KEY);
  if (!sessionId) {
    sessionId = uuidv4();
    localStorage.setItem(ANONYMOUS_SESSION_KEY, sessionId);
  }
  return sessionId;
};
